import type { SessionToken } from './types';

const STORAGE_KEY = 'gp_session_token';

export function saveToken(token: SessionToken): void {
  window.sessionStorage.setItem(STORAGE_KEY, token);
}

export function loadToken(): SessionToken | null {
  const raw = window.sessionStorage.getItem(STORAGE_KEY);
  return raw ? (raw as SessionToken) : null;
}

export function clearToken(): void {
  window.sessionStorage.removeItem(STORAGE_KEY);
}
